/**
 * Mobile navigation toggle
 *
 * Handles hamburger menu, aria attributes, body scroll lock,
 * Escape key close, and desktop breakpoint sync.
 */

/**
 * Initialise the navigation component.
 */
const initNavigation = () => {

	const hamburger = document.querySelector( '.p-header__hamburger' );
	const nav = document.getElementById( 'primary-nav' );

	if ( ! hamburger || ! nav ) {

		return;

	}

	const header = document.querySelector( '.p-header' );
	let previousScrollBehavior = '';
	let scrollPosition = 0;

	/**
	 * Lock page scrolling while mobile menu is open.
	 */
	const lockPageScroll = () => {

		scrollPosition = window.scrollY;
		previousScrollBehavior = document.documentElement.style.scrollBehavior;
		document.documentElement.style.scrollBehavior = 'auto';
		document.documentElement.classList.add( 'menu-open' );
		document.body.classList.add( 'menu-open' );
		document.body.style.top = `-${ scrollPosition }px`;

	};

	/**
	 * Restore page scrolling after mobile menu closes.
	 */
	const unlockPageScroll = () => {

		if (
			! document.documentElement.classList.contains( 'menu-open' )
			&& ! document.body.classList.contains( 'menu-open' )
		) {

			return;

		}

		const restoredScrollPosition = scrollPosition;

		document.documentElement.classList.remove( 'menu-open' );
		document.body.classList.remove( 'menu-open' );
		document.body.style.top = '';
		window.scrollTo( 0, restoredScrollPosition );

		window.requestAnimationFrame( () => {

			document.documentElement.style.scrollBehavior = previousScrollBehavior;

		} );

		scrollPosition = 0;

	};

	/**
	 * Open the mobile menu.
	 */
	const openMenu = () => {

		header.classList.add( 'p-header--menu-open' );
		hamburger.setAttribute( 'aria-expanded', 'true' );
		hamburger.setAttribute( 'aria-label', 'Zamknij menu' );
		nav.removeAttribute( 'hidden' );
		lockPageScroll();

		const firstLink = nav.querySelector( '.p-header__nav-link' );

		if ( firstLink ) {

			firstLink.focus();

		}

	};

	/**
	 * Close the mobile menu.
	 *
	 * @param {boolean} shouldFocusHamburger Should return focus to hamburger button.
	 */
	const closeMenu = ( shouldFocusHamburger = true ) => {

		header.classList.remove( 'p-header--menu-open' );
		hamburger.setAttribute( 'aria-expanded', 'false' );
		hamburger.setAttribute( 'aria-label', 'Otwórz menu' );
		nav.setAttribute( 'hidden', '' );
		unlockPageScroll();

		if ( shouldFocusHamburger ) {

			hamburger.focus( { preventScroll: true } );

		}

	};

	/**
	 * Check if menu is currently open.
	 *
	 * @return {boolean} True if menu is open.
	 */
	const isOpen = () => hamburger.getAttribute( 'aria-expanded' ) === 'true';

	hamburger.addEventListener( 'click', () => {

		if ( isOpen() ) {

			closeMenu();

		} else {

			openMenu();

		}

	} );

	// Close on Escape key.
	document.addEventListener( 'keydown', ( e ) => {

		if ( e.key === 'Escape' && isOpen() ) {

			closeMenu();

		}

	} );

	// Close mobile menu when clicking a nav link.
	nav.addEventListener( 'click', ( e ) => {

		if ( e.target.closest( '.p-header__nav-link' ) && isOpen() ) {

			closeMenu();

		}

	} );

	// On desktop, ensure nav is always visible.
	const navBreakpoint = window.matchMedia( '(min-width: 1200px)' );

	/**
	 * Handle breakpoint change between mobile and desktop.
	 *
	 * @param {MediaQueryList} mq The media query list object.
	 */
	const handleBreakpoint = ( mq ) => {

		if ( mq.matches ) {

			if ( isOpen() ) {

				closeMenu( false );

			}

			nav.removeAttribute( 'hidden' );
			header.classList.remove( 'p-header--menu-open' );
			unlockPageScroll();
			hamburger.setAttribute( 'aria-expanded', 'false' );
			hamburger.setAttribute( 'aria-label', 'Otwórz menu' );

		} else if ( ! isOpen() ) {

			nav.setAttribute( 'hidden', '' );

		}

	};

	navBreakpoint.addEventListener( 'change', handleBreakpoint );
	handleBreakpoint( navBreakpoint );

};

document.addEventListener( 'DOMContentLoaded', initNavigation );
